import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const addLink = (href: string, media?: string,  nonce?: string) => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  if (media) {
    link.media = media;
    link.onload = () => link.media = 'all';
  }

  if (nonce) {
    link.setAttribute('nonce', nonce);
  }
  document.head.appendChild(link);
};

// ✅ Estilos cargados desde node_modules a través de angular.json (compilados en styles.css)
addLink('styles.css', 'print', 'MjE0LDExNywzNSwxMTA='); // incluye bootstrap.min.css, material theme, toastr, y styles.scss

// ✅ Scripts cargados desde node_modules (compilados por Angular)
//addScript('scripts.js'); // incluye jquery.min.js y bootstrap.min.js

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
